import { AxiosError } from "axios"
import { z } from "zod"

export const ErrorResponse = z.object({
  statusCode: z.number(),
  message: z.union([z.string(), z.array(z.string())]),
})

export const parseAxiosError = (error: Error) => {
  let errorMessage = "An Error occurred"
  if (error instanceof AxiosError && error.response?.data) {
    const data = ErrorResponse.safeParse(error.response.data)
    if (data.success) {
      if (Array.isArray(data.data.message)) {
        errorMessage = data.data.message.join(", ")
      } else {
        errorMessage = data.data.message
      }
    }
  } else if (error instanceof Error) {
    errorMessage = error.message
  }
  return errorMessage
}
